import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ZipCodes } from 'src/app/features-common/constants/ZipCodes';
import { PasswordUpdateComponent } from './password-update/password-update.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ProfileService } from '../profile.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import * as moment from 'moment';
const helper = new JwtHelperService();

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent extends FeaturesBaseComponent implements OnInit {
  hide = true;
  user_id;
  updateProfileForm: FormGroup
  emailRegx = /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  phoneRegx = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
  public phone: Array<string | RegExp>;
  usStateZips: string[];
  languages: string[];
  profileDetails: any;
  selectedlanguage: any;
  selectedstate: any;
  fileToUpload: File;
  profilePicPath: any;
  profilePic: any;
  notificationMethod: string;
  selectedImageName: string ='';
  uploadpic: boolean = false;
  constructor(private dialog: MatDialog, private profileService: ProfileService, private router: Router) {
    super();
    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.usStateZips = ZipCodes.USAStatesShort;
    this.languages = ['English','Spanish'];

  }

  ngOnInit(): void {
    super.ngOnInit()
    this.initForm()
    let _token: string = localStorage.getItem('accessToken')
    const decodedToken = helper.decodeToken(_token);
    this.user_id = decodedToken.user_id;
    this.profileService.getprofiledata(this.user_id).subscribe(
      res => {
        let data: any = res;
        this.profileDetails = data.data;
       
        this.selectedlanguage = this.profileDetails.preferredLanguage;
        this.selectedstate = this.profileDetails.state;

        //profilePic: null
        this.profilePic = this.profileDetails?.profilePic;
        this.profilePicPath = this.profileDetails?.profilePicPath;
        //alert(this.profilePicPath)
        this.updateProfileForm.get('firstName').setValue(this.profileDetails.firstName);
        this.updateProfileForm.get('lastName').setValue(this.profileDetails.lastName);
        this.updateProfileForm.get('userName').setValue(this.profileDetails.userName);
        this.updateProfileForm.get('email').setValue(this.profileDetails.email);
        this.updateProfileForm.get('mobileNumber').setValue(this.profileDetails.mobileNumber);
        this.updateProfileForm.get('password').setValue(this.profileDetails.password.substr(0,12));
        this.updateProfileForm.get('address1').setValue(this.profileDetails.address1);
        this.updateProfileForm.get('city').setValue(this.profileDetails.city);
        this.updateProfileForm.get('state').setValue(this.profileDetails.state);
        this.updateProfileForm.get('zipcode').setValue(this.profileDetails.zipcode);
        this.updateProfileForm.get('preferredLanguage').setValue(this.profileDetails.preferredLanguage);
      })
  }
  initForm() {
    this.updateProfileForm = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      userName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.pattern(this.emailRegx)]),
      mobileNumber: new FormControl('', [Validators.required]),
      password: new FormControl('password', ),
      address1: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      zipcode: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')]),
      preferredLanguage: new FormControl('English', [Validators.required]),
      //profilePic: new FormControl(),
    })
  }
  get f(){
    return this.updateProfileForm.controls
  }
  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.toastrService.info('New Profile Image will reflect after saving changes', 'Info', {
      timeOut: 3000,
    });
    this.uploadpic = true;
   
    this.selectedImageName = this.fileToUpload.name
  }
  onUpdateProfile(){
    if (!this.updateProfileForm.valid){
      return
    }
    
    const formData: FormData = new FormData();
    //formData.append('priceListFile', this.fileToUpload, this.fileToUpload.name);
    formData.append('userId', this.user_id);
    formData.append('firstName', this.updateProfileForm.get('firstName').value);
    if (this.fileToUpload && this.fileToUpload){
      formData.append('profilePic', this.fileToUpload)
    }
    formData.append('lastName', this.updateProfileForm.get('lastName').value);
    formData.append('userName', this.updateProfileForm.get('userName').value);
    formData.append('email', this.updateProfileForm.get('email').value);
    formData.append('mobileNumber', this.updateProfileForm.get('mobileNumber').value);
    formData.append('password', this.updateProfileForm.get('password').value);
    formData.append('address1', this.updateProfileForm.get('address1').value);
    formData.append('city', this.updateProfileForm.get('city').value);
    formData.append('state', this.updateProfileForm.get('state').value);
    formData.append('zipcode', this.updateProfileForm.get('zipcode').value.toString());
    formData.append('preferredLanguage', this.updateProfileForm.get('preferredLanguage').value);
    this.profileService.updateProfile(formData).subscribe(
      res => {
        if (res && res) {
          if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success'){
            this.toastrService.success('Profile updated successfully', 'Success', {
              timeOut: 3000,
            });      
            this.reloadComponent();  
        }
      }
    });


  }

  onUpdatePassword(e){
    
    
    if ( this.updateProfileForm.dirty){      
      this.toastrService.warning('', 'Please save changes before updating password')
      return
    }

    const dialogRef = this.dialog.open(PasswordUpdateComponent, {
      width: '400px',
      data: {
        userName: this.updateProfileForm.get('userName').value,
        user_id: this.user_id,
        cntx: 'resetPrompt'
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        //call API to update profile
        let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
    });
      
    /*if (localStorage.getItem('userVerify') && localStorage.getItem('userVerify')) {
      let _userverify = JSON.parse(localStorage.getItem('userVerify'));

      this.notificationMethod = _userverify.notification == 'sms' ? "mobile number" : "email"
   
      this.profileService.getVerifyOtp(this.user_id, this.notificationMethod).subscribe((res)=>{
        if(res['httpcode'] == 200 ){}
       })
    }    */
  }


  ngOnDestroy() {
    super.ngOnDestroy()
  }
  checkSubmitDisplayed() {
    return (!this.uploadpic && !(this.updateProfileForm.valid && !this.updateProfileForm.pristine )); 
  }

  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }

}
